class commonHelper {
    constructor() {}

    expandContent() {
        if (window.innerWidth > 992) {

            var cards = document.querySelectorAll('.card-link');
            for (var i = 0; i < cards.length; i++) {
                let item = cards[i];
                item.addEventListener('mouseover', function () {
                    showButton(item)
                });
                item.addEventListener('focus', function () {
                    showButton(item)
                });
                item.addEventListener('mouseout', function () {
                    hideButton(item)
                });
                item.addEventListener('focusout', function () {
                    hideButton(item)
                });
            }
        }
        var showButton = function (item) {
            var button = item.querySelector('.collapse');
            var link = item.querySelector('.btn-arrow');
            $(link).addClass('fade');
            $(button).collapse('show');
        }
        var hideButton = function (item) {
            var button = item.querySelector('.collapse');
            $(button).collapse('hide');
        }
    }

    loadmore() {
        document.getElementById('loadmore').onclick = function () {

            var button = document.getElementById('loadmore');
            button.dataset.page = parseInt(button.dataset.page) + 1;

            var url = window.location.href;
            var newURL;

            var position = url.indexOf('?');

            if (position > -1) {

                var pageNumString = url.substring(position + 6, url.length);

                var pageNum = parseInt(pageNumString);

                pageNum++;

                newURL = url.replace(pageNumString, pageNum);

            } else {
                newURL = url + '?page=2';
            }

            history.pushState({state: 1, rand: Math.random()}, '', newURL);

            let data = {
                "action": "load_more_projects",
                "page": button.dataset.page,
                "postperpage": 5,
                "taxonomy": button.dataset.taxonomy,
                "slug": button.dataset.slug
            };

            $.post("/wp-admin/admin-ajax.php", data, function (response) {

                var button = document.getElementById('loadmore');

                if (response == 0) {
                    button.classList.add('d-none');
                } else {
                    $('#blog-posts').append(response);
                    //app.common.expandContent();
                }
            });
        };
    }

    loadmoreposts() {
        document.getElementById('loadmoreposts').onclick = function () {

            console.log('howdy!');

            var button = document.getElementById('loadmoreposts');
            button.dataset.page = parseInt(button.dataset.page) + 1;

            var url = window.location.href;
            var newURL;

            var position = url.indexOf('?');

            if (position > -1) {

                var pageNumString = url.substring(position + 6, url.length);

                var pageNum = parseInt(pageNumString);

                pageNum++;

                newURL = url.replace(pageNumString, pageNum);

            } else {
                newURL = url + '?page=2';
            }

            history.pushState({state: 1, rand: Math.random()}, '', newURL);

            let data = {
                "action": "load_more_posts",
                "page": button.dataset.page,
                "postperpage": 6,
                "taxonomy": button.dataset.taxonomy,
                "slug": button.dataset.slug
            };

            $.post("/wp-admin/admin-ajax.php", data, function (response) {

                console.log('response: ', response);

                var button = document.getElementById('loadmoreposts');

                if (response === 0) {
                    button.classList.add('d-none');
                } else {
                    $('#blog-posts').append(response);
                    //app.common.expandContent();
                }
            });
        };
    }

}

window.app.add('common', new commonHelper());